
'use strict';
var ActionTypes = require('../constants/ActionTypes');
var projectLoadHelper = require('../helper/projectLoadHelper');
var _ = require('underscore');
var logHelper = require('../helper/timeLogHelper');

function preLoadPage(id, cb) {
  projectLoadHelper.loadPage(id, function (err, page) {
    cb();
    if (err) {
      console.error(err);
      return;
    }
    if (!page) {
      console.warn('Cannot find this page', id);
    }
  });
}

function preLoadPages(IDs) {
  if (IDs.length === 0) {
    return;
  }
  var toLoadPageID = IDs.shift();
  preLoadPage(toLoadPageID, function () {
    setTimeout(function () {
      preLoadPages(IDs);
    }, 50);
  });
}

function findAllPageIDs(pages) {
  var IDs = [];
  _.each(pages, function (page) {
    if (!page.isModule) {
      IDs.push(page.ID);
    }
    if (page._pages) {
      IDs = IDs.concat(findAllPageIDs(page._pages));
    }
  });
  return IDs;
}

function preLoadAppPages(app) {
  var IDs = findAllPageIDs(app.modules._pages);
  preLoadPages(IDs);
}

function loadApp(app) {
  return function (dispatch) {
    dispatch(openPage(projectLoadHelper.getAppFirstPage().ID, function () {
      preLoadAppPages(app);
    }));
  };
}

function openPage(id, cb) {
  var start = Date.now();
  return function (dispatch) {
    dispatch(openPageRequest(id));
    projectLoadHelper.loadPage(id, function (err, page) {
      if (err) {
        dispatch(openPageFail(err));
        return;
      }
      if (!page) {
        alert('Cannot find this page');
      }
      page.ID = id;
      logHelper.logPageRead(id, page.title, Date.now() - start);
      dispatch(openPageDone(page));
      if (cb) {
        cb(err, page);
      }
    });
  };
}

function openPageRequest(id) {
  return {
    type: ActionTypes.PAGE_LOAD_REQUEST,
    payload: id
  };
}

function openPageDone(page) {
  return {
      type: ActionTypes.PAGE_LOAD_DONE,
      payload: page
  };
}

function openPageFail(err) {
  return {
    type: ActionTypes.PAGE_LOAD_FAIL,
    payload: err
  };
}

function redirectPage(id, animation) {
  return function (dispatch) {
    dispatch(redirectPageRequest(id));
    projectLoadHelper.loadPage(id, function (err, page) {
      if (err) {
        console.error(err);
        dispatch(redirectPageFail(err));
        return;
      }
      if (!page) {
        alert('Cannot find this page');
      }
      page.ID = id;
      dispatch(redirectPageDone(page, animation));
    });
  };
}

function redirectPageRequest(id) {
  return {
    type: ActionTypes.PAGE_REDIRECT_REQUEST,
    payload: id
  };
}

function redirectPageDone(page, animation) {
  return {
    type: ActionTypes.PAGE_REDIRECT_DONE,
    payload: {
      page: page,
      animation: animation
    }
  };
}

function redirectPageFail(err) {
  return {
    type: ActionTypes.PAGE_REDIRECT_FAIL,
    payload: err
  };
}

module.exports = {
  loadApp: loadApp,
  openPage: openPage,
  redirectPage: redirectPage
};


// WEBPACK FOOTER //
// ./src/actions/AppActions.js